module.exports = __webpack_public_path__ + "static/media/register 1 .8884ab96.svg";